<template>
    <div class="global-info global-info--dealer">
        <span class="index" v-if="index">{{ index }}</span>
        <address class="address" v-if="dealerMerged">
            <span><strong>{{ dealerMerged.name }}</strong></span>
                <template v-if="enabledTypeFilters" v-for="filter in enabledTypeFilters">
                    <span v-if="dealerMerged.dealerTypes.includes(filter.name)" class="typo-light">{{ filter.label }}</span>
                </template>
            <span class="spacer">
                <span>{{ dealerMerged.address }}</span>
                <span>{{ dealerMerged.zip }} {{ dealerMerged.city }}</span>
                <span>{{ countryName(dealerMerged.country) }}</span>
            </span>
            <span class="spacer">
                <p class="contact__phone" v-if="dealerMerged.phone">
                    {{ $t('global-info-dealer.phone') }}
                    <span>{{ dealerMerged.phone }}</span>
                </p>
                <p class="contact__fax" v-if="dealerMerged.phone">
                    {{ $t('global-info-dealer.fax') }}
                    <span>{{ dealerMerged.fax }}</span>
                </p>
                <p class="contact__email" v-if="dealerMerged.email !== ''">
                    {{ $t('global-info-dealer.email') }}
                    <a :href="'mailto:' + dealerMerged.email">{{ dealerMerged.email }}</a>
                </p>
                <p class="contact__web" v-if="dealerMerged.email !== ''">
                    {{ $t('global-info-dealer.web') }}
                    <a :href="validateLinkAddress(dealerMerged.web)" target="_blank">{{ dealerMerged.web }}</a>
                </p>
            </span>
            <global-button v-if="enableDealerSelection" theme="primary" @click="$emit('choose', dealerMerged)">{{ $t('global-info-dealer.button.chooseDealer') }}</global-button>
        </address>
    </div>
</template>

<script>
import {countryNameForIso2} from "@global/utilities/global-country-data"
import GlobalButton from "@global/global-elements/global-button/global-button";

export default {
    name: "global-info-dealer",
    components: {GlobalButton},
    props: {
        enabledTypeFilters: null,
        dealerProp: null,
        index: null,
        /** Is a dealer selectable? Emits 'choose' event */
        enableDealerSelection: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dealer: null
        }
    },
    computed: {
        dealerMerged() {
            return this.dealerProp || this.dealer;
        }
    },
    methods: {
        countryName(iso2) {
            return countryNameForIso2(iso2)
        },
        validateLinkAddress(link) {
            return /^http/.test(link) ? link: "http://" + link
        }
    }
}
</script>
